import React from 'react';
import '../styles/DetailedFeatures.css';

// Import images
import unified from '../../../../assets/solutions/edcato/unified.svg';
import stuLifecycle from '../../../../assets/solutions/edcato/stu_lifecycle.svg';
import finanAuto from '../../../../assets/solutions/edcato/finan_auto.svg';
import learnMgmt from '../../../../assets/solutions/edcato/learn_mgmt.svg';
import parTea from '../../../../assets/solutions/edcato/par-tea.svg';
import multiUser from '../../../../assets/solutions/edcato/multi_user.svg';
import mobFirst from '../../../../assets/solutions/edcato/mob_first.svg';

const DetailedFeatures = () => {
  const features = [
    {
      icon: unified,
      title: "Unified Platform",
      description: "Integrates school management and e-learning tools with a single sign-on system."
    },
    {
      icon: stuLifecycle,
      title: "Student Lifecycle Management",
      description: "Handles admissions, enrollments, attendance tracking, and detailed academic histories."
    },
    {
      icon: finanAuto,
      title: "Financial Automation",
      description: "Streamlines billing, payroll management, fee collection, scholarships, and financial reporting."
    },
    {
      icon: learnMgmt,
      title: "Learning Content Management",
      description: "Facilitates course creation, digital assignments, quizzes, and multimedia content."
    },
    {
      icon: parTea,
      title: "Parent-Teacher-Student Engagement",
      description: "Real-time notifications, messaging, and progress sharing create a connected educational community."
    },
    {
      icon: multiUser,
      title: "Multi-branch and Multi-user Management",
      description: "Supports centralized control of multiple campuses and diverse user roles."
    },
    {
      icon: mobFirst,
      title: "Mobile-First Experience",
      description: "Ensures full functionality on smartphones and tablets for learning and administration."
    }
  ];

  return (
    <section className="detailed-features">
      <div className="container">
        {/* Section Header */}
        <div className="section-header">
          <h1>
            Everything You Need in
            One Powerful Platform
          </h1>
          <p>
            Discover how Edcato revolutionizes education management with cutting-edge features designed for modern learning institutions.
          </p>
        </div>

        {/* Features Grid */}
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className={`feature-card card-${index + 1}`}>
              <div className="card-glow"></div>
              
              {/* Image container */}
              <div className="icon-container">
                <img 
                  src={feature.icon} 
                  alt={feature.title} 
                  className="feature-icon"
                />
              </div>

              {/* Content */}
              <div className="card-content">
                <h3 className="card-title">{feature.title}</h3>
                <p className="card-description">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DetailedFeatures;
